var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.route)?_c('router-link',{staticClass:"bc-notification-panel-item-label",attrs:{"to":_setup.route}},[_vm._v(" "+_vm._s(_setup.label)+" ")]):_c('span',{staticClass:"bc-notification-panel-item-label bcx-pointer",on:{"click":function($event){return _setup.gotoItem(_vm.type)}}},[_vm._v(_vm._s(_setup.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }